import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import {fuseAnimations} from '../../../../core/animations';
import { fromEvent as observableFromEvent, Subscription } from 'rxjs';
import {NgxSpinnerService} from 'ngx-spinner';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { EditRecommendationComponent } from '../edit-recommendation/edit-recommendation.component';
import { FuseConfigService } from '../../../../core/services/config.service';
import { BlogService } from '../../../../core/services/blog.service';
@Component({
  selector: 'recommend-blogs',
  templateUrl: './recommend-blogs.component.html',
  styleUrls: ['./recommend-blogs.component.scss'],
  animations: fuseAnimations,
  standalone: false
})
export class RecommendBlogs implements OnInit , OnDestroy {
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  _search = '';
  blogs = [];
  _pageIndex = 0;
  _perPage = 50;
  blogsLength ;
  displayedColumns = [ 'title' , 'organization', 'recommended', 'recommendedBy', 'recommendationText' ];
  userId;

  private subscriptions =  new Subscription();

  constructor (private blogService: BlogService , private spinner: NgxSpinnerService,
               public dialog: MatDialog, private translate: TranslateService,
               public toastr: ToastrService, private fuseConfig: FuseConfigService) {
    this.fuseConfig.userId.subscribe((res: any) => {
      if (res) {
        this.userId = res;
      }
    });
  }

  ngOnInit () {
    this.getBlogs();
    this.subscriptions.add(observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(1500) ,
      distinctUntilChanged())
      .subscribe(() => {
        if (this.filter.nativeElement.value && this.filter.nativeElement.value.replace(/ /g, '')
          && this.filter.nativeElement.value !== null && this.filter.nativeElement.value !== 'null') {
          this._search = this.filter.nativeElement.value;
          this.paginator.firstPage();
          this.cleanScrollEvent();
          this.getBlogs();
        } else if ((!this.filter.nativeElement.value || this.filter.nativeElement.value === '') && this._search){
          this._search = '';
          this.paginator.firstPage();
          this.cleanScrollEvent();
          this.getBlogs();
        }
      }));
  }

  getBlogs() {
    this.spinner.show();
    this.blogService.getBlogForRecommendation(this._pageIndex + 1, this._perPage, this._search).subscribe((response: any) => {
      this.blogsLength = response.length;
      let blogs = response.blogs;

      if (blogs.length) {
        this.blogs = blogs;
      } else {
        this.blogs = [];
      }
      this.spinner.hide();
    })
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  cleanScrollEvent() {
    let table = document.getElementById('recommendBlog');
    if (table) {
      table.scrollTop = 0;
    }
  }

  changePageEmitter(e) {
    this._pageIndex = e.pageIndex;
    this._perPage = e.pageSize;
    this.cleanScrollEvent();
    this.getBlogs();
  }

  editRecommendationBlog(e, blog, readonly = false) {
    e.preventDefault();
    const dialogRef = this.dialog.open(EditRecommendationComponent , {
      width: '500px', data:{ text: blog.recommendation[0].recommendation_text, readonly}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          blogId: blog.id,
          recommendation_text: result,
          id: blog.recommendation[0].id,
        };
        this.blogService.addRecommendation(data).subscribe((res: any) => {
          if (res) {
            let index = this.blogs.findIndex(el => +el.id === +blog.id);
            if (index !== -1) {
              this.blogs[index].recommendation[0].recommendation_text = res.recommendation_text;
            }
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('event.recommendation_text_edited');
            this.toastr.success(msg, title);
          }
        });
      }
    });
  }
}
